<div class="ex-outside">
	<a [routerLink]="[]" (click)="expanded = !expanded" class="ex-header">
		{{caption}} <span class="expander-button" [class.expanded]="expanded">▶</span>
	</a>
	<div *ngIf="expanded">
		<div class="ex-content">
			<ng-content></ng-content>
		</div>
	</div>
</div>